import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const allTagSelector = (state: State) => state.allTag.entities;
export const allTagStatusSelector = (state: State) => state.allTag.status;
export const allTagLoadedSelector = isLoaded(allTagStatusSelector);
export const shouldLoadAllListCompanySelector =
  shouldLoad(allTagStatusSelector);
export const allTagRejectedSelector = isRejected(allTagStatusSelector);
export const allTagPendingSelector = isPending(allTagStatusSelector);
